import { render, staticRenderFns } from "./_letter.vue?vue&type=template&id=581560a4&"
import script from "./_letter.vue?vue&type=script&lang=js&"
export * from "./_letter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/nuxt/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports